import React from 'react'
import { useContext } from 'react'
import _ from 'lodash'
import { AppContext } from '../context/AppContext'

const BookTripDetails = () => {

    const {setPrevPage, setNextPage, setGeoAddress} = useContext(AppContext)     
    setPrevPage("/")
    setNextPage('/booktrip/flextime')


    let numOptions = []
    _.times(10, (i) => {
        numOptions.push( <option value={i+1}>{i+1}</option>)
    })   
    
    const {tripDetails, setTripDetails} = useContext(AppContext)


    const updatetripDetails = (evt) => {
        setTripDetails({...tripDetails, [evt.target.id]: evt.target.value})
    } 


    const updatetripPassengers = (evt) => {

        setTripDetails(oldTripDetails => {
            ///const newPassengers = oldTripDetails.passengers.map((unused, i) => i == evt.target.index)
            const newPassengers = {...oldTripDetails.passengers, [evt.target.id]: evt.target.value}
            console.log(oldTripDetails.passengers, newPassengers,evt.target.value)
            return {...oldTripDetails, passengers: newPassengers}
        }) //SHOULD WORK WITH LIST
    }

    const updateGeoAddress = (evt) => {
        evt.preventDefault()
        setGeoAddress(tripDetails.destination)
    }
    

    let passengerFields = []
    _.times(tripDetails.travellers -1, (i) => {
        let j = i+2
        passengerFields.push(        
        <fieldset class="form-row">
            <label for="passenger-name"><h4>Passenger {j}:</h4></label>
            <input index={i+1} id={i+1} type="text" placeholder={"Lastname, firstname"} value={tripDetails.passengers[i+1]} onChange={updatetripPassengers}></input>
        </fieldset>
         )
    })

    return (
    <form onSubmit={updateGeoAddress} id="#booking-details" class="form">
        <fieldset class="form-row">
            <label for="book-to"><h4>Destination Address:</h4></label>
            <input onBlur={updateGeoAddress} id="destination" type="text" value={tripDetails.destination} onChange={updatetripDetails} placeholder="?"/>
        </fieldset>
        <fieldset class="form-row">
            <label for="book-number"><h4>Number of travelers:</h4></label>
            <select id="travellers" type="dropdown" value={tripDetails.travellers} onChange={updatetripDetails}>
                {numOptions}
            </select>
        </fieldset>
        <fieldset class="form-row">
        <label for="book-number"><h4>Date:</h4></label>
            <input id="date" type="date" value={tripDetails.date} onChange={updatetripDetails}/>
        </fieldset>
        <fieldset class="form-row">
            <label for="booker"><h4>Passenger 1 (booker):</h4></label>
            <input id="booker" type="text" placeholder={"Lastname, Firstname"} value={tripDetails.booker} onChange={updatetripDetails}/>
         </fieldset>
        {passengerFields}
       
    </form>
    )
}

export default BookTripDetails;